import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Filter the dev-only CRA error overlay so opaque cross-origin
// "Script error." noise from third-party embeds (e.g. JotForm) doesn't
// trigger the red overlay. Real bugs still surface normally.
if (process.env.NODE_ENV !== "production") {
  window.addEventListener(
    "error",
    (e) => {
      if (!e.message || e.message === "Script error.") {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true,
  );
  window.addEventListener("unhandledrejection", (e) => {
    const reason = e.reason;
    const msg = typeof reason === "string" ? reason : reason?.message || "";
    if (!msg || msg === "Script error.") {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}

// Cached query duration used by React Query.
const STALE_TIME_MS = 60_000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
